import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL + '/api';

/**
 * Create configured axios instance
 */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request interceptor to add auth token
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor for error handling
 */
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

/**
 * Get authorization headers with token
 */
export const getAuthHeaders = (contentType = 'application/json') => ({
  Authorization: `Bearer ${localStorage.getItem('authToken')}`,
  'Content-Type': contentType,
});
